module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value > 0) ? _c('span', {
    class: _vm.computedClass
  }, [_vm._v(" " + _vm._s(_vm.value) + " ")]) : _c('span', {
    class: _vm.computedClass
  }, [_vm._v(" " + _vm._s(_vm.$t('models.project.unsynced_leads_count_success')) + " ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-483d2363","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueUnsyncedCount.vue
// module id = 1893
// module chunks = 0